import { render } from "./Seats.vue?vue&type=template&id=02a436d7&ts=true"
import script from "./Seats.vue?vue&type=script&lang=ts"
export * from "./Seats.vue?vue&type=script&lang=ts"

import "./Seats.vue?vue&type=style&index=0&id=02a436d7&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__